export default class AbstractConfig {
    constructor() {
        this._data = {};
    }

    setPropertiesFromObject(obj) {
        this._data = obj;
    }

    getValue(label) {
        return _find(this._data, label);
    }

    setValue(label, value) {
        this._data[label] = value;
    }

    clear() {
        this._data = {};
    }
}

const _find = function (obj, path) {
    path = path.split('.');
    var len = path.length;

    for (var i = 0; i < len; i++) {
        obj = obj[path[i]];
    };
    return obj;
}